/* src/app/master-data/roles/form-role/form-role.component.css */
/*# sourceMappingURL=form-role.component-IHCDQC6Y.css.map */
